module.exports = __webpack_public_path__ + "static/media/elo.2636e8f6.png";